import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var superAdminLoginRes;
export const superAdminLoginTodo = createAsyncThunk('superAdminLogin', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'superadmin/login',
            data: {
                "username": data.email,
                "password": data.password,
                // "deviceType": "master"
            },
            headers: { "Content-Type": "application/json" }
        })
        return superAdminLoginRes = res.data

    } catch (error) {
        return superAdminLoginRes = error.response.data
    }
})
